module.exports = __webpack_public_path__ + "media/in_the_silo.030ed5af.wav";